import { Progress } from './Progress'

type Props = {
  winDistribution: number[]
  isLatestGame: boolean
  isGameWon: boolean
  isGameLost: boolean
  numberOfGuessesMade: number
}

// Slot 6 is the "X" row (ran out of guesses).
const LOSS_SLOT = 6

const isCurrentDayStatRow = (
  isLatestGame: boolean,
  isGameWon: boolean,
  isGameLost: boolean,
  numberOfGuessesMade: number,
  i: number
) => {
  if (!isLatestGame) return false
  if (isGameLost) return i === LOSS_SLOT
  return isGameWon && numberOfGuessesMade === i + 1
}

export const Histogram = ({
  winDistribution,
  isLatestGame,
  isGameWon,
  isGameLost,
  numberOfGuessesMade,
}: Props) => {
  const maxValue = Math.max(...winDistribution, 1)

  return (
    <div className="justify-left m-2 columns-1 text-sm dark:text-white">
      {winDistribution.map((value, i) => (
        <Progress
          key={i}
          index={i}
          isCurrentDayStatRow={isCurrentDayStatRow(
            isLatestGame,
            isGameWon,
            isGameLost,
            numberOfGuessesMade,
            i
          )}
          isLoss={i === LOSS_SLOT}
          size={90 * (value / maxValue)}
          label={String(value)}
        />
      ))}
    </div>
  )
}
